import { Platform, StyleSheet } from 'react-native';
import { tokens } from '../../../../constants';
export var getPrependAppendItemStyles = () => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    itemRightSpacing: {
      marginRight: tokens.spacing.SPACING_4
    },
    defaultCursor: Object.assign({}, Platform.select({
      web: {
        cursor: 'default'
      }
    })),
    button: {
      paddingVertical: 0
    },
    tooltipStyle: {
      justifyContent: 'center'
    }
  });
};
export var getAppendPrependColorConfig = function getAppendPrependColorConfig(props, disabled, textAsAction, isActionable, customColor) {
  if (disabled === void 0) {
    disabled = false;
  }
  if (textAsAction === void 0) {
    textAsAction = false;
  }
  if (isActionable === void 0) {
    isActionable = false;
  }
  if (customColor === void 0) {
    customColor = '';
  }
  var _config = props.config,
    variantStyle = props.variantStyle;
  var config = variantStyle !== 'default' ? _config.newStates : _config.states;
  var iconColor = config.none.appendPrependIconColor;
  var textColor = config.none.appendPrependTextColor;
  if (textAsAction) textColor = config.none.appendPrependTextAsActionColor;
  if (isActionable) iconColor = config.none.appendPrependIsActionableColor;
  if (customColor) iconColor = customColor;
  if (disabled) {
    iconColor = config.disabled.appendPrependIconColor;
    textColor = config.disabled.appendPrependTextColor;
  }
  return {
    iconColor,
    textColor
  };
};